var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBanana = function SvgBanana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#banana_svg__a)",
    d: "M47 113c5.982 0 40.254 34.865 77.529 34.4s97.1-29.467 103.081-31.309 14.7 5.832 13.225 14.045c-3.1 17.264-29.792 66.989-114.005 68.83-60.272 1.319-105.383-43.279-96.639-74.2 3.012-10.653 2.3-33.04 0-35.82s-1.524-11.572 4.6-9.686c5.982 1.841 7.823 1.381 8.743 4.6S47 113 47 113"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#banana_svg__b)",
    d: "M47 113c5.981 0 28.966 45.455 85.6 45.455 37.267 0 94.538-39.766 100.76-40.428 2.8-.3 8.886 3.9 7.411 12.114-3.1 17.264-29.783 66.989-113.972 68.83-60.254 1.319-105.35-43.279-96.61-74.2 3.011-10.653 2.3-33.04 0-35.82s-1.524-11.572 4.6-9.686c5.981 1.841 7.821 1.381 8.741 4.6S47 113 47 113"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#banana_svg__c)",
    d: "M30 81s3.065 4.6 6.511 2.649c0 0 2.448 5.351 3.43 5.351a5.93 5.93 0 0 0 3.683-2.676c.737-1.7.246-7.54-.245-11.432S39.715 71 39.715 71s.226 3.892-.756 4.865a6.13 6.13 0 0 1-3.438 1.946C32.084 78.749 31 79 30 81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#banana_svg__d)",
    d: "M229.68 116.4c1.068.543 2.7 1.207 3.211 1.991s3.441 4.827 4.616 5.1 3.008 2.2 3.468 1.237-5.475-8.191-7.826-9.277c-2.228-1.026-5.604-.132-3.469.949"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "banana_svg__a",
    x1: 37.269,
    x2: 152.155,
    y1: 107.677,
    y2: 245.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banana_svg__b",
    x1: 50.199,
    x2: 264.301,
    y1: 136.721,
    y2: 195.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banana_svg__c",
    x1: 37.112,
    x2: 36.603,
    y1: 88.19,
    y2: 70.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2890BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banana_svg__d",
    x1: 229.504,
    x2: 241.424,
    y1: 117.428,
    y2: 124.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7EAF3"
  })))));
};
export default SvgBanana;